import { useTranslation } from 'react-i18next'
import { Stack, Checkbox, Group, Anchor, Text, Alert } from '@mantine/core'
import { TextDescriptionRight } from 'shared/ui/TextDescriptionRight/TextDescriptionRight'
import { useSelector } from 'react-redux'
import { BalancePaymentOption } from 'features/paymentFromBalance'
import { useAppDispatch } from 'shared/hooks/useAppDispatch/useAppDispatch'
import { CarouselBankCards } from 'features/fastPaymentCards'
import { useResponsive } from 'shared/hooks/useResponsive/useResponsive'
import { IconInfoSquareFilled } from '@tabler/icons-react'
import { getPaymentPrice } from '../../model/selectors/getPaymentPrice'
import { getPaymentProduct } from '../../model/selectors/getPaymentProduct'
import { getPaymentPeriod } from '../../model/selectors/getPaymentPeriod'
import { getPaymentAcceptOffer } from '../../model/selectors/getPaymentAcceptOffer'
import { getPaymentPayFromBalance } from '../../model/selectors/getPaymentPayFromBalance'
import { paymentActions } from '../../model/slices/paymentSlice'
import { getPaymentCurrentBalance } from '../../model/selectors/getPaymentCurrentBalance'
import { getPaymentMessage } from '../../model/selectors/getPaymentMessage'
import { PaymentButton } from '../PaymentButton/PaymentButton'

interface PaymentMainProps {}

export const PaymentMain = () => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const { xs } = useResponsive()

    const acceptOffer = useSelector(getPaymentAcceptOffer)
    const payFromBalance = useSelector(getPaymentPayFromBalance)
    const product = useSelector(getPaymentProduct)
    const period = useSelector(getPaymentPeriod)
    const price = useSelector(getPaymentPrice)
    const currentBalance = useSelector(getPaymentCurrentBalance)
    const message = useSelector(getPaymentMessage)

    const handleAcceptOffer = (value: boolean) => {
        dispatch(paymentActions.reducerAcceptOffer(value))
    }
    const onCloseAlert = () => {
        dispatch(paymentActions.reducerPaymentMessage(''))
    }

    return (
        <Stack spacing="xl">
            {!!message && (
                <Alert
                    title="Внимание!"
                    icon={<IconInfoSquareFilled />}
                    color="blue"
                    withCloseButton
                    onClose={onCloseAlert}
                >
                    {message}
                </Alert>
            )}
            <TextDescriptionRight leftText={product.title} rightText={product.name} />
            {period.title && <TextDescriptionRight leftText={period.title} rightText={period.name} />}
            <TextDescriptionRight leftText={price.title} rightText={`${price.name} руб.`} />
            <BalancePaymentOption />
            <Group position="apart">
                <Text fw={600} fz="xl">
                    Итого к оплате:
                </Text>
                <Text fw={600} fz="xl">
                    {price.name} руб.
                </Text>
            </Group>
            <Checkbox
                checked={acceptOffer}
                onChange={(event) => handleAcceptOffer(event.currentTarget.checked)}
                radius="xs"
                label={
                    <>
                        Согласен с условиями{' '}
                        <Anchor href="https://yourtunes.net/usloviya-oferty" target="_blank">
                            оферты
                        </Anchor>
                    </>
                }
            />
            {(!payFromBalance || (payFromBalance && Number(price.name) > Math.floor(currentBalance))) && (
                <CarouselBankCards sliderSize={xs ? '60%' : '33%'} />
            )}
            <PaymentButton buttonType="main" />
        </Stack>
    )
}
